export default __webpack_public_path__ + "static/media/MaskVideo.808dac0d.png";